const getNow = (withDate = true, withTime = true) => {
	const date = new Date()
	const formatedDate = `${date.getFullYear()}-${date.getMonth()}-${date.getUTCDate()}`
	const formatedTime = `${date.getHours()}-${date.getMinutes()}-${date.getSeconds()}`
	if (withDate && withTime) {
		return `${formatedDate}_${formatedTime}`
	}
	if (withDate && !withTime) {
		return formatedDate
	}
	if (!withDate && withTime) {
		return formatedTime
	}
}

export default getNow
